<template>
<div class="row document-upload">
    <div class="col-sm-12">
        <legend>Required Documents:</legend>
        <div class="pt-20" >
            <div v-for="(d, index) in documentArr" :key="index" class="uploaded-documents">
                <div
                    :class="
                    d.added
                        ? 'uploaded-documents_uploaded'
                        : 'uploaded-documents_not-uploaded'
                    "
                >
                    <i
                    :class="
                        d.added ? 'el-icon-check' : 'el-icon-close'
                    "
                    ></i>
                    <span> {{ d.name }} </span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'register-files',
    props: { 
      initialDocumentArr: {
        type: Array,
        default: () => []
      },
      submittedTypes: {
        type: Array,
        defalt:()=>[]
      }
    },
    watch: {
        initialDocumentArr(newValue, oldValue) {
            this.documentArr = newValue;
        },
        submittedTypes(newValue, oldValue) {
            if(newValue.length > 0) {
                for(let i=0; i<this.documentArr.length; i++) {
                    let d = this.documentArr[i];
                    if(newValue.find(f => f === d.name) !== undefined) {
                        d.added = true;
                    } else {
                        d.added = false;
                    }
                }
            } else {
                for(let i=0; i<this.documentArr.length; i++) {
                    this.documentArr[i].added = false;
                }
            }
        }
    },
    data: () => ({
        documentArr: [],
        trainingDocumentStatus: false,
        memoDocumentStatus: false
    }),
    methods: {
      
    },
    mounted() {
    },
  };
  </script>
  <style scoped lang="scss">
    .document-upload{
        margin-top: 20px;
    }
    .uploaded-documents {
        font-weight: 500;
        padding-right: 0.3em;
        &_uploaded {
            color: #10b45a;
            i {
                color: #10b45a;
            }
        }

        &_not-uploaded {
            color: #606266; 
            i {
                color: red;
            }
        }
    }
</style>

